<template>
  <div class="page-core">
    <!-- 返回主页 -->
    <div class="page-section">
      <router-link to="/">返回首页</router-link>
    </div>

    <!-- 房间参数设置区域 -->
    <div class="page-section">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">房间参数：</el-col>
      </el-row>
      <el-row :gutter="16">
        <!-- sdkAppId -->
        <el-col :span="12">
          <el-input
            placeholder="sdkAppId"
            v-model="roomState.sdkAppId"
            type="number"
            @change="changeRoomState('sdkAppId', $event)"
          >
            <template slot="prepend">sdkAppId</template>
          </el-input>
        </el-col>
        <!-- sdkSecretKey -->
        <el-col :span="12">
          <el-input
            placeholder="sdkSecretKey"
            v-model="roomState.sdkSecretKey"
            @change="changeRoomState('sdkSecretKey', $event)"
          >
            <template slot="prepend">sdkSecretKey</template>
          </el-input>
        </el-col>
        <!-- roomId -->
        <el-col :span="12">
          <el-input
            placeholder="roomId"
            v-model="roomState.roomId"
            type="number"
            @change="changeRoomState('roomId', $event)"
          >
            <template slot="prepend">roomId</template>
          </el-input>
        </el-col>
        <!-- userId -->
        <el-col :span="12">
          <el-input
            placeholder="userId"
            v-model="roomState.userId"
            @change="changeRoomState('userId', $event)"
          >
            <template slot="prepend">userId</template>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <!-- 媒体设备选择区域 -->
    <div class="page-section">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">
          媒体
          <el-tooltip content="参数更改后，要重新加入房间才会生效">
            <i
              class="el-icon-question"
              style="color: #e6a23c; margin-left: 5px"
            ></i>
          </el-tooltip>
          ：
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <!-- 摄像头选择 -->
        <el-col :span="12">
          <el-select
            v-model="profile.cameraId"
            placeholder="请选择摄像头"
            style="width: 100%"
            @change="(value) => changeProfile('cameraId', value)"
          >
            <el-option-group label="摄像头列表">
              <el-option
                v-for="item in camerasList"
                :key="item.deviceId"
                :label="item.label || item.deviceId"
                :value="item.deviceId"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-col>
        <!-- 麦克风选择 -->
        <el-col :span="12">
          <el-select
            v-model="profile.microphoneId"
            placeholder="请选择麦克风"
            style="width: 100%"
            @change="(value) => changeProfile('microphoneId', value)"
          >
            <el-option-group label="麦克风列表">
              <el-option
                v-for="item in microphonesList"
                :key="item.deviceId"
                :label="item.label || item.deviceId"
                :value="item.deviceId"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <!-- 操作按钮区域 -->
    <div class="page-section">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">操作：</el-col>
      </el-row>
      <!-- 房间操作按钮 -->
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-button-group>
          <el-button
            type="primary"
            :disabled="roomStatus === 'entered'"
            @click="handle_enterRoom"
          >
            加入房间
          </el-button>
          <el-button type="primary" @click="handle_leaveRoom">
            离开房间
          </el-button>
        </el-button-group>
      </el-row>
      <!-- 摄像头操作按钮 -->
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-button-group>
          <el-button
            type="primary"
            :disabled="camStatus === 'started'"
            @click="handleStartLocalVideo"
          >
            采集摄像头
          </el-button>
          <el-button
            type="primary"
            :loading="camStatus === 'stopping'"
            @click="handleStopLocalVideo"
          >
            终止采集摄像头
          </el-button>
        </el-button-group>
      </el-row>
      <!-- 麦克风操作按钮 -->
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-button-group>
          <el-button
            type="primary"
            :disabled="micStatus === 'started'"
            @click="handleStartLocalAudio"
          >
            采集麦克风
          </el-button>
          <el-button
            type="primary"
            :loading="micStatus === 'stopping'"
            @click="handleStopLocalAudio"
          >
            终止采集麦克风
          </el-button>
        </el-button-group>
      </el-row>
      <!-- 屏幕共享操作按钮 -->
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-button-group>
          <el-button
            type="primary"
            :disabled="shareStatus === 'shared'"
            @click="handleStartScreenShare"
          >
            开启屏幕共享
          </el-button>
          <el-button type="primary" @click="handleStopScreenShare">
            关闭屏幕共享
          </el-button>
        </el-button-group>
      </el-row>
    </div>

    <!-- 日志显示区域 -->
    <div class="page-section">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">日志：</el-col>
      </el-row>
      <el-row :gutter="16" style="margin-bottom: 10px">
        <div class="log-container" ref="logContainer">
          <div v-for="(item, index) in logList" :key="index">
            <span class="log-state" v-if="item.type === 'success'">🟩 </span>
            <span class="log-state" v-if="item.type === 'failed'">🟥 </span>
            <span>{{ item.log }}</span>
          </div>
        </div>
      </el-row>
    </div>

    <!-- 本地视频流区域 -->
    <div class="page-section" v-show="camStatus === 'started'">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">本地视频流：</el-col>
      </el-row>
      <el-row :gutter="16" style="margin-bottom: 10px">
        <div id="local" class="local-stream-content"></div>
        <div class="local-stream-control">
          <div class="video-control control">
            <span v-if="!isMutedVideo" @click="muteVideo">
              <i class="el-icon-camera-solid"></i>
            </span>
            <span v-if="isMutedVideo" @click="unmuteVideo">
              <i class="el-icon-camera"></i>
            </span>
          </div>
          <div class="audio-control control">
            <span v-if="!isMutedAudio" @click="muteAudio">
              <i class="el-icon-microphone"></i>
            </span>
            <span v-if="isMutedAudio" @click="unmuteAudio">
              <i class="el-icon-turn-off-microphone"></i>
            </span>
          </div>
        </div>
      </el-row>
    </div>

    <!-- 远程视频流列表 -->
    <div class="page-section">
      <el-row :gutter="16" style="margin-bottom: 10px">
        <el-col :span="24">远程视频流：</el-col>
      </el-row>
      <el-row :gutter="16" style="margin-bottom: 10px">
        <div
          v-for="item in remoteUsersViews"
          :key="item"
          :id="item"
          class="remote-stream-container"
        ></div>
      </el-row>
    </div>
  </div>
</template>

<script>
import TRTC from 'trtc-sdk-v5';
import LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js';

export default {
  name: 'demoPage',
  data() {
    return {
      // ---- 媒体权限 -----
      hasMediaPermission: false, // 是否有媒体权限
      // ---- trtc实例 -----
      trtc: null, // trtc实例
      roomStatus: 'exited', // exited, exiting, entering, entered
      camStatus: 'stopped', // stopped, starting, started, stopping
      micStatus: 'stopped', // stopped, starting, started, stopping
      shareStatus: 'stopped', // stopping, stopped, sharing, shared
      isMutedVideo: false,
      isMutedAudio: false,
      // ---- 房间参数、视频参数、音频参数 -----
      roomState: {
        sdkAppId: 1600098115, // 必须是number类型
        sdkSecretKey:
          'b4175b3a6ac588851b783bbca5d4450c2bf4b723ac66def262e49bc8c7e66113',
        roomId: 4567, // 必须是number类型
        userId: 'Jiekee',
        userSig: '',
      }, // 房间参数配置
      profile: {}, // 视频参数配置
      camerasList: [], // 摄像头列表
      microphonesList: [], // 麦克风列表
      // ---- 日志 -----
      logList: [], // 日志列表
      // ---- 播放窗口 -----
      remoteUsersViews: [], // 远端用户列表
      // ---- 其他 -----
      // gutter: 16, // 布局间距
    };
  },
  watch: {
    // 监测-媒体权限变化
    hasMediaPermission(newVal) {
      if (newVal && this.trtc) {
        console.log(`---- 媒体权限发生变化,获取摄像头和麦克风列表 -----`);
        this.getCamerasList();
        this.getMicrophonesList();
      }
    },
    // 监测-视频参数变化
    'profile.cameraId'(newVal, oldVal) {
      this.switchDevice('video', newVal);
    },
    'profile.microphoneId'(newVal, oldVal) {
      this.switchDevice('audio', newVal);
    },
  },
  created() {
    // 取媒体权限
    this.utils_getMediaPermission();
    // 初始化trtc实例
    this.initTRTC();
  },
  mounted() {
    // 监听设备列表变化
    navigator.mediaDevices.addEventListener(
      'devicechange',
      this.getCamerasList
    );
    navigator.mediaDevices.addEventListener(
      'devicechange',
      this.getMicrophonesList
    );
  },
  beforeDestroy() {
    // 移除监听设备列表变化
    navigator.mediaDevices.addEventListener(
      'devicechange',
      this.getCamerasList
    );
    navigator.mediaDevices.addEventListener(
      'devicechange',
      this.getMicrophonesList
    );
  },
  methods: {
    // ---- 权限相关方法 -----
    // 获取媒体权限
    async utils_getMediaPermission() {
      try {
        await Promise.allSettled([
          this.utils_getCameraPermission(),
          this.utils_getMicrophonePermission(),
        ]);
        this.hasMediaPermission = true;
        console.log(`---- 获取媒体权限成功 -----`);
      } catch (error) {
        console.error(error);
        this.$message.error('获取媒体权限失败');
      }
    },
    // 获取摄像头权限
    utils_getCameraPermission() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            stream.getTracks().forEach((track) => {
              track.stop();
            });
            resolve();
          })
          .catch((err) => {
            console.log('err', err);
            this.$message.error(
              `获取媒体权限失败，请检查摄像头是否被占用: ${err}`
            );
            reject(err);
          });
      });
    },
    // 获取麦克风权限
    utils_getMicrophonePermission() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            stream.getTracks().forEach((track) => {
              track.stop();
            });
            resolve();
          })
          .catch((err) => {
            console.log('err', err);
            this.$message.error(
              `获取媒体权限失败，请检查麦克风是否被占用: ${err}`
            );
            reject(err);
          });
      });
    },
    // 获取摄像头列表
    async getCamerasList() {
      // 获取摄像头列表
      const res = await TRTC.getCameraList();
      const list = res || [];
      this.camerasList = list.filter((item) => item.deviceId);
      console.log('---- 摄像头列表 -----', this.camerasList);
      // 设置默认摄像头
      this.changeProfile('cameraId', this.camerasList[0].deviceId);
    },
    // 获取麦克风列表
    async getMicrophonesList() {
      // 获取麦克风列表
      const res = await TRTC.getMicrophoneList();
      const listFilter = res.reduce((acc, current) => {
        const x = acc.find((item) => item.groupId === current.groupId);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      this.microphonesList = listFilter.filter((item) => item.deviceId);
      console.log('---- 麦克风列表 -----', this.microphonesList);
      // 设置默认麦克风
      this.changeProfile('microphoneId', this.microphonesList[0].deviceId);
    },
    // ---- trtc实例相关方法 -----
    // 初始化trtc实例
    initTRTC() {
      if (this.trtc) return;
      this.trtc = TRTC.create();
      console.log(`---- 初始化trtc实例成功 -----`);
    },
    // 加入房间
    async enterRoom() {
      this.roomStatus = 'entering';
      this.initTRTC();
      try {
        await this.trtc.enterRoom({
          sdkAppId: parseInt(this.roomState.sdkAppId, 10),
          roomId: this.roomState.roomId,
          userId: this.roomState.userId,
          userSig: this.roomState.userSig,
        });
        this.roomStatus = 'entered';

        this.installEventHandlers();
        this.startGetAudioLevel();
        this.addSuccessLog(`Enter room [${this.roomId}] success.`);
      } catch (error) {
        this.roomStatus = 'exited';
        console.error('enterRoom room failed', error);
        this.addFailedLog(
          `Enter room ${this.roomId} failed, please check your params. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 退出房间
    async exitRoom() {
      if (this.roomStatus !== 'entered') {
        this.addFailedLog('The room has not been entered');
        return;
      }
      this.roomStatus = 'exiting';
      this.stopGetAudioLevel();

      try {
        await this.trtc.exitRoom();
        this.roomStatus = 'exited';
        this.remoteUsersViews = [];
        this.uninstallEventHandlers();

        this.addSuccessLog('Exit room success.');
      } catch (error) {
        this.roomStatus = 'entered';
        this.addFailedLog(`Exit room failed. Error: ${error.message}`);
        throw error;
      }

      if (this.micStatus === 'started') this.handleStopLocalAudio();
      if (this.camStatus === 'started') this.handleStopLocalVideo();
      if (this.shareStatus === 'shared') this.handleStopScreenShare();
    },
    // 禁相机
    async muteVideo() {
      try {
        await this.trtc.updateLocalVideo({ mute: true });
        this.isMutedVideo = true;
        this.addSuccessLog('Mute video success.');
      } catch (error) {
        this.addFailedLog(`Mute video error: ${error.message}`);
      }
    },
    // 禁音频
    async muteAudio() {
      try {
        await this.trtc.updateLocalAudio({ mute: true });
        this.isMutedAudio = true;
        this.addSuccessLog('Mute audio success.');
      } catch (error) {
        this.addFailedLog(`Mute audio error: ${error.message}`);
      }
    },
    // 开相机
    async unmuteVideo() {
      try {
        await this.trtc.updateLocalVideo({ mute: false });
        this.isMutedVideo = false;
        this.addSuccessLog('Unmute video success.');
      } catch (error) {
        this.addFailedLog(`Unmute video error: ${error.message}`);
      }
    },
    // 开音频
    async unmuteAudio() {
      try {
        await this.trtc.updateLocalAudio({ mute: false });
        this.isMutedAudio = false;
        this.addSuccessLog('Unmute audio success.');
      } catch (error) {
        this.addFailedLog(`Unmute audio error: ${error.message}`);
      }
    },
    // 切换设备
    async switchDevice(type, deviceId) {
      try {
        if (type === 'video' && this.camStatus === 'started') {
          await this.trtc.updateLocalVideo({
            option: { cameraId: deviceId },
          });
          this.addSuccessLog(`Switch ${type} device success.`);
        }
        if (type === 'audio' && this.micStatus === 'started') {
          await this.trtc.updateLocalAudio({
            option: { microphoneId: deviceId },
          });
          this.addSuccessLog(`Switch ${type} device success.`);
        }
      } catch (error) {
        console.error('switchDevice failed', error);
        this.addFailedLog(`Switch ${type} device failed.`);
      }
    },
    // 开始获取音频
    startGetAudioLevel() {
      this.trtc.on(TRTC.EVENT.AUDIO_VOLUME, (event) => {
        event.result.forEach(({ userId, volume }) => {
          const isMe = userId === '';
          if (isMe) {
            console.log(`my volume: ${volume}`);
          } else {
            console.log(`user: ${userId} volume: ${volume}`);
          }
        });
      });
      this.trtc.enableAudioVolumeEvaluation(2000);
    },
    // 停止获取音频
    stopGetAudioLevel() {
      this.trtc && this.trtc.enableAudioVolumeEvaluation(-1);
    },
    // 注册事件监听
    installEventHandlers() {
      this.trtc.on(TRTC.EVENT.ERROR, this.handleError);
      this.trtc.on(TRTC.EVENT.KICKED_OUT, this.handleKickedOut);
      this.trtc.on(TRTC.EVENT.REMOTE_USER_ENTER, this.handleRemoteUserEnter);
      this.trtc.on(TRTC.EVENT.REMOTE_USER_EXIT, this.handleRemoteUserExit);
      this.trtc.on(
        TRTC.EVENT.REMOTE_VIDEO_AVAILABLE,
        this.handleRemoteVideoAvailable
      );
      this.trtc.on(
        TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE,
        this.handleRemoteVideoUnavailable
      );
      this.trtc.on(
        TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE,
        this.handleRemoteAudioUnavailable
      );
      this.trtc.on(
        TRTC.EVENT.REMOTE_AUDIO_AVAILABLE,
        this.handleRemoteAudioAvailable
      );
      this.trtc.on(
        TRTC.EVENT.SCREEN_SHARE_STOPPED,
        this.handleScreenShareStopped
      );
    },
    // 取消事件监听
    uninstallEventHandlers() {
      this.trtc.off(TRTC.EVENT.ERROR, this.handleError);
      this.trtc.off(TRTC.EVENT.KICKED_OUT, this.handleKickedOut);
      this.trtc.off(TRTC.EVENT.REMOTE_USER_ENTER, this.handleRemoteUserEnter);
      this.trtc.off(TRTC.EVENT.REMOTE_USER_EXIT, this.handleRemoteUserExit);
      this.trtc.off(
        TRTC.EVENT.REMOTE_VIDEO_AVAILABLE,
        this.handleRemoteVideoAvailable
      );
      this.trtc.off(
        TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE,
        this.handleRemoteVideoUnavailable
      );
      this.trtc.off(
        TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE,
        this.handleRemoteAudioUnavailable
      );
      this.trtc.off(
        TRTC.EVENT.REMOTE_AUDIO_AVAILABLE,
        this.handleRemoteAudioAvailable
      );
      this.trtc.off(
        TRTC.EVENT.SCREEN_SHARE_STOPPED,
        this.handleScreenShareStopped
      );
    },
    // 事件-错误事件
    handleError(error) {
      this.addFailedLog(`Local error: ${error.message}`);
      alert(error);
    },
    // 事件-退出事件
    async handleKickedOut(event) {
      this.addFailedLog(`User has been kicked out for ${event.reason}`);
      this.trtc = null;
      await this.exitRoom();
    },
    // 事件-远端用户进入事件
    handleRemoteUserEnter(event) {
      const { userId } = event;
      this.addSuccessLog(`Remote User [${userId}] entered`);
    },
    // 事件-远端用户退出事件
    handleRemoteUserExit(event) {
      this.addSuccessLog(`Remote User [${event.userId}] exit`);
    },
    // 事件-远端视频激活事件
    handleRemoteVideoAvailable(event) {
      const { userId, streamType } = event;
      try {
        this.addSuccessLog(`[${userId}] [${streamType}] video available`);
        if (streamType === TRTC.TYPE.STREAM_TYPE_MAIN) {
          this.remoteUsersViews.push(`${userId}_main`);
          this.$nextTick(async () => {
            await this.trtc.startRemoteVideo({
              userId,
              streamType,
              view: `${userId}_main`,
            });
          });
        } else {
          this.remoteUsersViews.push(`${userId}_screen`);
          this.$nextTick(async () => {
            await this.trtc.startRemoteVideo({
              userId,
              streamType,
              view: `${userId}_screen`,
            });
          });
        }
        this.addSuccessLog(`Play remote video success: [${userId}]`);
      } catch (error) {
        this.addFailedLog(
          `Play remote video failed: [${userId}], error: ${error.message}`
        );
      }
    },
    // 事件-远端视频取消激活事件
    handleRemoteVideoUnavailable(event) {
      this.addSuccessLog(
        `[${event.userId}] [${event.streamType}] video unavailable`
      );
      const { streamType } = event;
      this.trtc.stopRemoteVideo({ userId: event.userId, streamType });
      if (streamType === TRTC.TYPE.STREAM_TYPE_MAIN) {
        this.remoteUsersViews = this.remoteUsersViews.filter(
          (userId) => userId !== `${event.userId}_main`
        );
      } else {
        this.remoteUsersViews = this.remoteUsersViews.filter(
          (userId) => userId !== `${event.userId}_screen`
        );
      }
    },
    // 事件-远端音频激活事件
    handleRemoteAudioAvailable(event) {
      this.addSuccessLog(`[${event.userId}] audio available`);
    },
    // 事件-远端音频取消激活事件
    handleRemoteAudioUnavailable(event) {
      this.addSuccessLog(`[${event.userId}] audio unavailable`);
    },
    // 事件-取消屏幕共享事件
    handleScreenShareStopped() {
      this.shareStatus = 'stopped';
      this.addSuccessLog('Stop share screen success');
    },
    // ---- 房间参数、视频参数相关的方法 -----
    // 改变房间参数
    changeRoomState(target, value) {
      this.roomState = {
        ...this.roomState,
        [target]: value,
      };
    },
    // 改变视频配置
    changeProfile(target, value) {
      this.profile = {
        ...this.profile,
        [target]: value,
      };
    },
    // ---- 操作按钮相关的事件处理 -----
    // 监听-加入房间
    async handle_enterRoom() {
      // 检测配置
      if (!this.roomState.sdkAppId || !this.roomState.sdkSecretKey) {
        alert('请输入 sdkAppId 或 sdkSecretKey');
        return;
      }
      if (!this.roomState.roomId || !this.roomState.userId) {
        alert('请输入 roomId 或 userId');
        return;
      }
      // 生成userSig
      const userSigGenerator = new LibGenerateTestUserSig(
        this.roomState.sdkAppId,
        this.roomState.sdkSecretKey,
        604800
      );
      this.roomState.userSig = userSigGenerator.genTestUserSig(
        this.roomState.userId
      );
      // 进入房间
      await this.enterRoom();
      // 采集麦克风
      this.handleStartLocalAudio();
      // 采集摄像头
      this.handleStartLocalVideo();
    },
    // 监听-退出房间
    async handle_leaveRoom() {
      await this.exitRoom();
    },
    // 监听-采集麦克风
    async handleStartLocalAudio() {
      this.micStatus = 'starting';
      this.initTRTC();
      try {
        await this.trtc.startLocalAudio({
          option: {
            microphoneId: this.profile.microphoneId,
          },
        });
        this.isMutedAudio = false;
        this.micStatus = 'started';
        this.addSuccessLog('Local audio started successfully');
      } catch (error) {
        this.micStatus = 'stopped';
        this.addFailedLog(
          `Local audio is failed to started. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-终止采集麦克风
    async handleStopLocalAudio() {
      if (this.micStatus !== 'started') {
        this.addFailedLog('The audio has not been started');
        return;
      }
      this.micStatus = 'stopping';
      this.initTRTC();
      try {
        await this.trtc.stopLocalAudio();
        this.micStatus = 'stopped';
        this.addSuccessLog('Local audio stopped successfully');
      } catch (error) {
        this.micStatus = 'started';
        this.addFailedLog(
          `Local audio is failed to stopped. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-采集摄像头
    async handleStartLocalVideo() {
      this.camStatus = 'starting';
      this.initTRTC();
      try {
        await this.trtc.startLocalVideo({
          view: 'local',
          option: {
            cameraId: this.profile.cameraId,
            profile: '1080p',
          },
        });
        this.camStatus = 'started';
        this.isMutedVideo = false;
        this.addSuccessLog('Local video started successfully');
      } catch (error) {
        this.camStatus = 'stopped';
        this.addFailedLog(
          `Local video is failed to started. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-终止采集摄像头
    async handleStopLocalVideo() {
      if (this.camStatus !== 'started') {
        this.addFailedLog('The video has not been started');
        return;
      }
      this.camStatus = 'stopping';
      this.initTRTC();
      try {
        await this.trtc.stopLocalVideo();
        this.camStatus = 'stopped';
        this.addSuccessLog('Local audio stopped successfully');
      } catch (error) {
        this.camStatus = 'started';
        this.addFailedLog(
          `Local audio is failed to stopped. Error: ${error.message}`
        );
        throw error;
      }
    },
    // 监听-开始屏幕共享
    async handleStartScreenShare() {
      if (!this.roomState.sdkAppId || !this.roomState.sdkSecretKey) {
        alert('请输入sdkAppId 和 sdkSecretKey');
        return;
      }
      this.shareStatus = 'sharing';
      try {
        await this.trtc.startScreenShare();
        this.shareStatus = 'shared';
        this.addSuccessLog('Start share screen success');
      } catch (error) {
        this.shareStatus = 'stopped';
        this.addFailedLog(`Start share error: ${error.message}`);
      }
    },
    // 监听-关闭屏幕共享
    async handleStopScreenShare() {
      if (this.shareStatus !== 'shared') {
        this.addFailedLog('The Share is not started');
        return;
      }
      this.shareStatus = 'stopping';
      try {
        await this.trtc.stopScreenShare();
        this.shareStatus = 'stopped';
        this.addSuccessLog('Stop share screen success');
      } catch (error) {
        this.shareStatus = 'shared';
        this.addFailedLog(`Stop share error: ${error.message}`);
      }
    },
    // ---- 日志相关的方法 -----
    // 新增成功的日志
    addSuccessLog(log) {
      this.logList.push({
        type: 'success',
        log,
      });
      if (this.$refs.logContainer) {
        const { scrollHeight } = this.$refs.logContainer;
        this.$refs.logContainer.scrollTop = scrollHeight;
      }
    },
    // 新增失败的日志
    addFailedLog(log) {
      this.logList.push({
        type: 'failed',
        log,
      });
      if (this.$refs.logContainer) {
        const { scrollHeight } = this.$refs.logContainer;
        this.$refs.logContainer.scrollTop = scrollHeight;
      }
    },
  },
};
</script>

<style scoped>
/* 页面样式 */
.page-core {
  padding: 16px;
}
.page-section {
  margin-bottom: 16px;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
}
/* 日志区域样式 */
.log-container {
  flex-grow: 1;
  border: 1px solid #dddddd;
  height: 360px;
  padding: 10px;
  margin-right: 16px;
  overflow-y: scroll;
}
.log-container .log-label {
  margin: 0 0 6px;
  font-weight: bold;
}
.log-container .log-state {
  display: inline-block;
  margin-right: 6px;
}
.log-container > div {
  font-size: 12px;
}
/* 本地视频流区域 */
.local-stream-content {
  width: 100%;
  height: 100%;
}
.local-stream-control {
  width: 100%;
  height: 30px;
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.local-stream-control .control {
  margin-left: 10px;
  margin-right: 10px;
}
.local-stream-control .icon-class {
  color: #fff;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
/* 远程视频流区域 */
.remote-stream-container {
  width: 320px;
  height: 240px;
  margin: 0 10px 10px 0;
}
</style>
